// src/utils/cookies.ts
export const getCookie = (name: string): string | null => {
  const m = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/([$?*|{}\]\\^])/g, '\\$1') + '=([^;]*)'),
  );
  return m ? decodeURIComponent(m[1]) : null;
};

// Определяем домен для cookie: .example.com для subdomain, без Domain для localhost/IP
const getCookieDomain = (): string | null => {
  const host = window.location.hostname;
  const isIp = /^\d{1,3}(\.\d{1,3}){3}$/.test(host);
  if (host === 'localhost' || isIp) return null;
  const parts = host.split('.');
  if (parts.length < 2) return null;
  // берём последние 2 части: example.com → .example.com
  return `.${parts.slice(-2).join('.')}`;
};

type SetCookieOpts = {
  days?: number;
  path?: string;
  sameSite?: 'Lax' | 'Strict' | 'None';
  secure?: boolean;
};

export const setCookie = (name: string, value: string, opts: SetCookieOpts = {}) => {
  const {
    days = 365,
    path = '/',
    sameSite = 'Lax',
    secure = window.location.protocol === 'https:',
  } = opts;

  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  const domain = getCookieDomain();

  let cookie = `${name}=${encodeURIComponent(
    value,
  )}; Expires=${expires}; Path=${path}; SameSite=${sameSite}`;
  if (secure) cookie += `; Secure`;
  if (domain) cookie += `; Domain=${domain}`;

  document.cookie = cookie;
};
